<div class="container">
  <div class="fixed-buttons">
    <div class="button-container">
      <button class="action-button" mat-raised-button matTooltip="Gå tillbaka till föregående sida"
        (click)="goBack()"><mat-icon fontIcon="arrow_back" class="button-icon-no-text"></mat-icon></button>
    </div>
  </div>

  @if (isLoading) {
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  }

  @if (contractor && !isLoading) {
  <div class="base-info-container">

    <h4 class="header">Entreprenörsuppgifter</h4>
    <div class="base-info">

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Organisationsnr</div>
          <div class="readonly-text">{{ contractor.organisationNumber }}</div>
        </div>
        <app-copy-to-clipboard-button [valueToCopy]="contractor.organisationNumber"></app-copy-to-clipboard-button>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Företagsnamn</div>
          <div class="readonly-text">{{ contractor.companyName }}</div>
        </div>
        <app-copy-to-clipboard-button [valueToCopy]="contractor.companyName"></app-copy-to-clipboard-button>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Adress</div>
          <div class="readonly-text">{{ contractor.streetAddress }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Postnr</div>
          <div class="readonly-text">{{ contractor.postalCode }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Ort</div>
          <div class="readonly-text">{{ contractor.city }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Medlem i SLA</div>
          <div class="readonly-text">{{ contractor.slaMember }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Entreprenörslistan</div>
          <div class="readonly-text">{{ contractor.contractorListStatus }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Kontakt</div>
          <div class="readonly-text">{{ contractor.contactName }}</div>
        </div>
      </div>

      <div class="field-with-copy field-with-text-area">
        <div class='fm-readonly-div' subscriptSizing="dynamic">
          <div class="readonly-header">Telefonnr</div>
          <div class="readonly-text">{{ contractor.contactPhone }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">E-post</div>
          <div class="readonly-text">{{ contractor.contactEmail }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Kontaktregistret ID</div>
          <div class="readonly-text">{{ contractor.contactRegisterId }}</div>
        </div>
        <app-copy-to-clipboard-button [valueToCopy]="contractor.contactRegisterId"></app-copy-to-clipboard-button>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Utför föryngringsavverkning</div>
          <div class="readonly-text">{{ contractor.performsLogging }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Utför gallring</div>
          <div class="readonly-text">{{ contractor.performsThinning }}</div>
        </div>
      </div>

      <div class="field-with-copy">
        <div class='fm-readonly-div'>
          <div class="readonly-header">Uppdaterad</div>
          <div class="readonly-text">{{ contractor.lastModified }}</div>
        </div>
      </div>
      <!-- FÅ MED AKTIV HÄR -->
    </div>
  </div>
  <div class="table-container">
    <div class="base-info-container">
      <div class="machine-list-header">
        <h4 class="header">Maskiner</h4>
        <mat-checkbox type="checkbox" [formControl]="showDeactivatedCheckbox">Visa inaktiva maskiner</mat-checkbox>
      </div>
      @if (contractorMachinesDataSource) {
      <mat-table [dataSource]="contractorMachinesDataSource" class="mat-elevation-8">

        <ng-container matColumnDef="machineId">
          <mat-header-cell *matHeaderCellDef> Maskinnr </mat-header-cell>
          <mat-cell *matCellDef="let contractorMachine" class="clickable-cell"
            (click)="navigateToMachine(contractorMachine.id)">
            {{ contractorMachine.machineId }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="machineStatusText">
          <mat-header-cell *matHeaderCellDef>Status </mat-header-cell>
          <mat-cell *matCellDef="let contractorMachine">
            {{ contractorMachine.statusText }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="machineTeam">
          <mat-header-cell *matHeaderCellDef> Maskinlag </mat-header-cell>
          <mat-cell *matCellDef="let contractorMachine;">
            <div class="machine-team-cell">
              @for (machineTeam of contractorMachine.contractorMachineTeams; track $index) {
              <div class="regular-link" (click)="navigateToTeam(machineTeam)">
                {{getMachineTeamIdsAsString(machineTeam) }} {{ getMachineNamesAsString(machineTeam) }}
              </div>
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="machineTeamStatusText">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let contractorMachine">
            <div class="machine-team-cell">
              @for (machineTeam of contractorMachine.contractorMachineTeams; track $index) {
              <div>
                {{ getTeamStatusTextAsString(machineTeam) }}
              </div>
              }
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      }

    </div>
  </div>
  }
</div>